import { authApiService } from '@/api/authApiService';
import { ApiResponseType, AuthResponseType } from '@/types/sharedTypes';

export type SetPasswordPayloadType = {
  password: string;
};

export const setPasswordApi = async (data: SetPasswordPayloadType): Promise<ApiResponseType<AuthResponseType>> => {
  const uri = '/users/auth/password:set/';

  return authApiService.POST(uri, data);
};
